import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__common_pdsTv_mjs_94e66c17__ from "../../../../../../common/pdsTv.mjs";
const buttonStyles = (0, __WEBPACK_EXTERNAL_MODULE__common_pdsTv_mjs_94e66c17__.pdsTv)({
    base: 'ptw-w-auto ptw-rounded ptw-bg-primary-base ptw-p-4 hover:ptw-bg-primary-active focus-visible:ptw-focus-visible disabled:ptw-bg-disabled-base disabled:ptw-text-disabled-text',
    variants: {
        width: {
            auto: 'ptw-w-auto',
            full: 'ptw-w-full'
        },
        buttonColor: {
            primary: '',
            secondary: 'ptw-bg-secondary-base ptw-text-secondary-text hover:ptw-bg-secondary-active'
        },
        buttonStyle: {
            solid: 'ptw-text-primary-text',
            outlined: 'ptw-border-radius-base ptw-border-medium ptw-border-primary-base ptw-bg-utils-transparent ptw-text-primary-base hover:ptw-bg-primary-active hover:ptw-text-primary-text',
            tonal: 'ptw-bg-primary-base/[0.1] ptw-text-primary-base hover:ptw-bg-primary-active hover:ptw-text-primary-text',
            text: 'ptw-bg-utils-transparent ptw-text-primary-base hover:ptw-bg-primary-active hover:ptw-text-primary-text'
        },
        size: {
            small: 'ptw-px-4 ptw-py-3 ptw-text-body-sm',
            medium: 'ptw-px-5 ptw-py-4 ptw-text-body-md',
            large: 'ptw-px-6 ptw-py-5 ptw-text-title-sm'
        }
    },
    compoundVariants: [
        {
            buttonStyle: 'outlined',
            buttonColor: 'secondary',
            class: 'ptw-border-secondary-base !ptw-text-secondary-base hover:ptw-bg-secondary-active hover:ptw-text-secondary-text'
        },
        {
            buttonStyle: 'tonal',
            buttonColor: 'secondary',
            class: 'ptw-bg-secondary-tonal ptw-text-secondary hover:ptw-bg-secondary-active hover:ptw-text-secondary-text'
        },
        {
            buttonStyle: 'text',
            buttonColor: 'secondary',
            class: 'ptw-text-secondary hover:ptw-bg-utils-transparent hover:ptw-text-secondary-active'
        }
    ]
});
const Button = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ buttonColor, width, buttonStyle, className, size, as: Component = 'button', ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Component, {
        type: "button",
        className: buttonStyles({
            buttonColor,
            width,
            buttonStyle,
            size,
            className
        }),
        ref: ref,
        ...props,
        children: props.children
    }));
export { Button, buttonStyles };
